import { CIMSModule, CIMSPage, Permission } from 'shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function usePayItems() {
  return useProtectedMenuItem({
    module: CIMSModule.PayItems,
    pages: [
      {
        page: CIMSPage.PayItemsSummary,
        permission: Permission.ViewPayItemSummary,
      },
      {
        page: CIMSPage.ManagePayItems,
        permission: [
          Permission.ViewPayItemConnection,
          Permission.ViewPayItemConnectionGroup,
        ],
      },
    ],
  })
}
